import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';

@Component({
  template: `
    <div class="d-flex justify-content-center align-items-center">
      <img
        *ngIf="rowData.type === 'form'"
        (click)="openDetail.emit(rowData)"
        title="Acciones"
        src="assets/images/icons/next.svg"
        class="hover-cursor-pointer" width="35px"
      >
      <img
        *ngIf="rowData.type === 'download'"
        (click)="openDetail.emit(rowData)"
        title="Acciones"
        src="assets/images/icons/download.svg"
        class="hover-cursor-pointer" width="35px"
      >
    </div>
  `,
})
export class ValidateOpenOptionComponent implements ViewCell {
  @Input() value: any;    // This hold the cell value
  @Input() rowData: any;  // This holds the entire row object
  @Output() openDetail: EventEmitter<any> = new EventEmitter();

  ngOnInit () {
    // console.log(this.rowData)
  }
}
